// Módulo para obtener suprazones
/* eslint-disable */
import axios from 'axios'

const baseUrl = process.env.VUE_APP_BASE_API + '/excursion/suprazones/'

const state = {
  suprazones: []
}

const actions = {

  loadSuprazones({
    commit
  }) {
    axios
      .get(baseUrl)
      .then(r => r.data)
      .then(suprazones => {
        commit('SET_SUPRAZONES', suprazones)
      })
  },

  async createSuprazone({
    commit, dispatch
  }, data) {
    await axios
      .post(baseUrl, data.payload)
      .then( response => {
        dispatch('loadSuprazones')
        return response.data
      })
    
  },

  async updateSuprazone({
    commit, dispatch
  }, data) {
    await axios
      .patch(baseUrl + data.suprazone_id + '/', data.payload)
      .then( response => {
        dispatch('loadSuprazones')
        return response.data
      })
    
  },

  async deleteSuprazone({
    commit, dispatch
  }, data) {
    return axios
      .delete(baseUrl + data.suprazone_id + '/')
      
  }

}

const mutations = {

  SET_SUPRAZONES(state, suprazones) {
    state.suprazones = suprazones
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
